export const messages = {
  fi: {
    search: "Kirjoita hakusana",
    all: "Kaikki",
    year: "Vuosi",
    month: "Kuukausi",
  },
  en: {
    search: "Enter search-term",
    all: "All",
    year: "Year",
    month: "Month",
  },
  sv: {
    search: "Skriv sökord",
    all: "Alla",
    year: "År",
    month: "Månad",
  },
};

export const months = (lang: string): Array<string> => {
  switch (lang) {
    case "fi":
      return [
        "Kuukausi",
        "Tammikuu",
        "Helmikuu",
        "Maaliskuu",
        "Huhtikuu",
        "Toukokuu",
        "Kesäkuu",
        "Heinäkuu",
        "Elokuu",
        "Syyskuu",
        "Lokakuu",
        "Marraskuu",
        "Joulukuu",
      ];
    case "sv":
      return [
        "Månad",
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "October",
        "November",
        "December",
      ];
    default:
      return [
        "Month",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
  }
};
